import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Eye, EyeOff } from "lucide-react";
import { useAuth } from "../components/AuthContext";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await axios.post("https://langbridge-backend.onrender.com/api/auth/login", formData);
      login(res.data.token); 
      navigate("/dashboard");
    } catch (err) {
      setError(err.response?.data?.message || "Login failed");
    }

    setLoading(false);
  };

  return (
    <div className="bg-gradient-to-br from-blue to-purple min-h-screen">
      <div className="flex flex-col lg:flex-row">
        {/* Left: Gradient with Logo and tagline */}
        <div className="hidden lg:flex flex-1 text-white flex-col justify-center items-center p-12">
          <h1 className="text-4xl font-bold mb-4">LangBridge</h1>
          <p className="text-lg text-center max-w-md">
            Bridge the gap between you and fluency. Learn smart, learn better.
          </p>
        </div>

        {/* Right: Login Form */}
        <div className="flex-1 flex items-center justify-center p-6 bg-gray-50 pt-32">
          <form
            onSubmit={handleSubmit}
            className="w-full max-w-md bg-white shadow-xl p-8 rounded-2xl"
          >
            <h2 className="text-2xl font-semibold mb-6 text-center">Login</h2>

            {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Email</label>
              <input
                type="email"
                name="email"
                onChange={handleChange}
                value={formData.email}
                required
                className="w-full border px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-blue"
              />
            </div>

            <div className="mb-6">
              <label className="block text-sm font-medium mb-1">Password</label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  onChange={handleChange}
                  value={formData.password}
                  required
                  className="w-full border px-4 py-2 rounded-lg outline-none focus:ring-2 focus:ring-blue pr-10"
                />
                <div
                  className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-gray-500"
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </div>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-blue text-white py-2 rounded-lg hover:bg-purple transition-colors"
            >
              {loading ? "Logging in..." : "Login"}
            </button>

            <p className="mt-4 text-sm text-center">
              Don’t have an account?{" "}
              <Link to="/register" className="text-blue hover:underline">
                Register here
              </Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
